var render, staticRenderFns
import script from "./UiRichRadioOption.vue?vue&type=script&lang=js"
export * from "./UiRichRadioOption.vue?vue&type=script&lang=js"
import style0 from "./UiRichRadioOption.vue?vue&type=style&index=0&id=4bb79e82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb79e82",
  null
  
)

export default component.exports